import { transformSearch } from "@/api/helper";
import notificationService from "@/features/dashboard/api/services/notification-service.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";

export const notificationSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	category: z.string().optional(),
	calendar_id: z.string().optional(),
});

export const notificationsQueryOptions = (
	search?: z.infer<typeof notificationSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["notifications", search],
		queryFn: () =>
			notificationService.list(transformSearch(search, ["category"])),
		...options,
	});
};

export const unreadNotificationsQueryOptions = (options?: {
	enabled: boolean;
}) => {
	return queryOptions({
		queryKey: ["unread_notification"],
		queryFn: () => notificationService.unreadNotifications(),
		...options,
	});
};

export const useReadNotificationMutation = () => {
	return useMutation({
		mutationKey: ["notifications"],
		mutationFn: notificationService.readNotifications,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["unread_notification"] });
			queryClient.invalidateQueries({ queryKey: ["notifications"] });
		},
	});
};
